import upload from "./upload";
import readFileContent from "./readFileContent";
import type { Request, UploadRequest, UploadResponse } from "./types";

const getCustomUploadRequest = (request: Request, isPublic: boolean): UploadRequest => {
  const uploadRequest: UploadRequest = async ({ file, onError, onSuccess }) => {
    const { type: contentType } = file;
    const content = await readFileContent(file);

    let response: UploadResponse;

    try {
      response = await upload(request, isPublic, contentType, content);

    } catch (error) {
      onError(error);

      return;
    }

    onSuccess(response);
  };

  return uploadRequest;
};

export default getCustomUploadRequest;
